import React, { useEffect, useState } from "react";
import Select from "react-select";

const customStyles = {
  option: (base, { isDisabled }) => ({
    ...base,
    backgroundColor: isDisabled ? "#E8E8E8" : "white",
    color: "black",
  }),
};

const SubscriptionDetails = ({
  selectedSubscription,
  onClose,
  selectedChef,
  setShowConfirmPopup,
  updatedOrderedItems,
  setUpdatedOrderedItems,
  chefs,
  handleChefClick,
}) => {
  const [showChefs, setShowChefs] = useState(false);

  useEffect(() => {
    if (selectedSubscription) {
      setUpdatedOrderedItems(
        selectedSubscription.orderedItems.map((item) => ({
          ...item,
          chefCharge: item.chefCharge || 0,
          actualChefCharge: item.chefCharge || 0,
        }))
      );

      const modalElement = document.getElementById("subscriptionModal");
      const modal = new window.bootstrap.Modal(modalElement);
      modal.show();

      return () => {
        modal.hide();
      };
    }
  }, [selectedSubscription]);

  const handleClose = () => {
    const modalElement = document.getElementById("subscriptionModal");
    const modal = new window.bootstrap.Modal(modalElement);
    modal.hide();
    onClose();
    setShowChefs(false);
  };

  const handleChefPriceChange = (index, value) => {
    const numericValue = parseFloat(value) || 0;
    setUpdatedOrderedItems((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, chefCharge: numericValue, actualChefCharge: numericValue } : item
      )
    );
  };

  const handleAssignChef = () => {
    const allFilled = updatedOrderedItems.every(
      (item) =>
        item.chefCharge !== null &&
        item.chefCharge !== undefined &&
        item.chefCharge !== 0
    );

    if (!allFilled) {
      alert("Please fill all chef prices before assigning a chef.");
      return;
    }
    setShowChefs(false);
    setShowConfirmPopup(true);
    setUpdatedOrderedItems(updatedOrderedItems);
  };

  if (!selectedSubscription) return null;

  const {
    subscriptionID,
    chefName,
    menuType,
    subscriptionType,
    noOfDays,
    noOfDaysLeft,
    craverDetails,
    deliverBy,
    distance,
    specialCookingInstruction,
  } = selectedSubscription;

  return (
    <div
      className="modal fade"
      id="subscriptionModal"
      tabIndex="-1"
      aria-labelledby="subscriptionModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="subscriptionModalLabel">
              Subscription Details
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row mb-3">
              <div className="col">
                <strong>Subscription ID:</strong> {subscriptionID}
              </div>
              <div className="col">
                <strong>Menu Type:</strong> {menuType}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <strong>Subscription Type:</strong> {subscriptionType}
              </div>
              <div className="col">
                <strong>Days:</strong> {noOfDaysLeft}/{noOfDays}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <strong>Craver Name:</strong> {craverDetails.craverName}
              </div>
              <div className="col">
                <strong>Craver Mobile:</strong> {craverDetails.craverMobile}
              </div>
            </div>
            <div className="mb-3">
              <strong>Craver Address:</strong>{" "}
              {`${craverDetails.craverHouseNo}, ${craverDetails.craverApartmentName}, ${craverDetails.craverLandmark}, ${craverDetails.craverAddress}`}
            </div>
            {distance ? (
              <div className="mb-2">
                <strong>Distance:</strong> {distance}
              </div>
            ) : null}
            <div className="row mb-2">
              <div className="col">
                <strong>Deliver By:</strong> {deliverBy}
              </div>
              <div className="col">
                <strong>Special Instructions:</strong>{" "}
                {specialCookingInstruction}
              </div>
            </div>
            {chefName ? (
              <div className="mb-2">
                <strong>Assigned To:</strong> {chefName}
              </div>
            ) : null}
            {showChefs && (
              <Select
                styles={customStyles}
                options={chefs}
                onChange={handleChefClick}
              />
            )}

            <div className="row">
              {updatedOrderedItems.map((item, index) => (
                <div className="col-6 mb-3" key={index}>
                  <div>
                    <strong>{item.menuName}</strong> *{" "}
                    <strong>{item.quantity}</strong>
                  </div>
                  <div>
                    <small>₹{item.menuPrice}</small>
                  </div>
                  {item.chefCharge !== 0 ? (
                    <div>
                      <small>
                        <strong>chefCharge: </strong>₹{item.chefCharge}/serving
                      </small>
                    </div>
                  ) : null}
                  <div>
                    <small>{item.itemType}</small>
                  </div>
                  <div>
                    <small>{item.description}</small>
                  </div>
                  {showChefs && selectedChef !== null ? (
                    <div className="input-group mb-3">
                      <span
                        className="input-group-text"
                        id={`chef-price-${index}`}
                      >
                        Chef Price
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter chef price"
                        aria-label="chef price"
                        aria-describedby={`chef-price-${index}`}
                        value={item.chefCharge}
                        onChange={(e) =>
                          handleChefPriceChange(index, e.target.value)
                        }
                      />
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
            <div className="row">
              <button
                type="button"
                className="btn btn-primary mt-3"
                onClick={() => setShowChefs((prev) => !prev)}
              >
                {showChefs ? "Hide" : "Show"} chef to select
              </button>

              {showChefs ? (
                <button
                  type="button"
                  className="btn btn-primary mt-3"
                  onClick={handleAssignChef}
                >
                  Assign chef
                </button>
              ) : null}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionDetails;
